import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Andrej Sharapov
 * id 67BA915E-B44A-434E-95D3-9BD94A174164
 * name account-badge
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-badge.svg
 * tags
 * - Account / User 
 */
export const AccountBadgeIcon = createSvgIcon(<><path d="M14 19.5C14 17.5 15.1 15.7 16.7 14.8C15.4 14.3 13.8 14 12 14C7.6 14 4 15.8 4 18V20H14V19.5M19.5 16C17.6 16 16 17.6 16 19.5S17.6 23 19.5 23 23 21.4 23 19.5 21.4 16 19.5 16M16 8C16 10.2 14.2 12 12 12S8 10.2 8 8 9.8 4 12 4 16 5.8 16 8Z" /></>, 'AccountBadgeIcon');
export default AccountBadgeIcon